module.exports = __webpack_public_path__ + "static/media/m4cr128.785fa0bf.png";